<template>
  <div id="">
    <!-- <span class="tram-title basisInformation">教师管理</span> -->
    <!-- <el-divider></el-divider> -->
    <el-row :gutter="12">
      <el-col :span="24" class="col-header">
        <el-card shadow="never"> 教师管理</el-card>
      </el-col>
    </el-row>
    <!-- 头部功能区域 -->
    <el-row>
      <!-- 头部左侧 -->
      <el-col class="col_form">
        <el-form :model="teacher" :inline="true">
          <el-form-item>
            <el-input
              size="small"
              v-model.trim="teacher.name"
              placeholder="姓名"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              size="small"
              v-model.trim="teacher.mobile"
              placeholder="手机号"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              size="small"
              clearable
              v-model="teacher.departmentId"
              placeholder="请选择科室"
            >
              <el-option
                v-for="item in departmentList"
                :key="item.departmentId"
                :label="item.departmentName"
                :value="item.departmentId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              size="small"
              placeholder="请选择状态"
              v-model="teacher.active"
              style="width: 120px"
              clearable
            >
              <el-option label="全部状态" value=""></el-option>
              <el-option label="已登录" value="1"></el-option>
              <el-option label="未登录" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
          </el-form-item>
          <el-form-item v-if="authSource == 'system'">
            <el-button
              size="small"
              type="primary"
              @click="addEditorDialog = true"
              >添加教师</el-button
            >
          </el-form-item>
          <el-form-item v-if="authSource == 'system'">
            <el-button size="small" type="primary" @click="batchDialog = true"
              >批量导入</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              @click="getApiExportTeacherList"
              >一键导出</el-button
            >
          </el-form-item>
          <el-form-item v-if="authSource == 'system'">
            <el-button
              @click="onClearTeacherDivision"
              size="small"
              type="primary"
              >一键清除教师分工</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- 教师列表区域 -->
    <el-table
      :row-style="{ height: '48px' }"
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      :data="teachersList"
      stripe
      border
      style=""
    >
      <el-table-column property="name" label="姓名" width="150" align="center">
        <!-- <template slot-scope="scope">
          <ww-open-data
            v-if="authSource != 'system'"
            type="userName"
            :openid="scope.row.name"
          ></ww-open-data>
          <span v-else>{{ scope.row.name }}</span>
        </template> -->
      </el-table-column>
      <el-table-column
        property="mobile"
        label="手机号"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column property="subjects" label="教师分工" align="center">
        <template v-slot="scope">
          <div v-for="(item, index) in scope.row.ShowWorkList" :key="index">
            <span style="margin-right: 10px">{{ item.subjectName }}:</span>
            <template v-for="(k, idx) in scope.row.workList">
              <span
                style="margin: 0 5px"
                :key="idx"
                v-if="k.subjectName == item.subjectName"
              >
                {{ k.gradeName }}
                <span>{{ k.classesName }}</span>
              </span>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        property="departmentName"
        label="所属科室"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column label="角色" width="200" align="center">
        <template slot-scope="scope">
          <span
            v-for="item in scope.row.roleType"
            :class="[
              {
                'is-Teacher': item != '教师',
              },
            ]"
            :key="item"
            @click="DeleteTeacherRole(item, scope.row)"
            >{{ item }}
          </span>
        </template>
      </el-table-column>
      <!-- 是否激活 -->
      <el-table-column
        property="isActive"
        label="登录状态"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          {{ scope.row.active == 1 ? '已登录' : '未登录' }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="420"
        align="center"
        v-if="authSource == 'system'"
      >
        <template v-slot="scope">
          <el-button type="text" size="mini" @click="teacherLabor(scope.row)"
            >教师分工</el-button
          >

          <el-button
            type="text"
            v-if="roleTypes == 'school' ? true : false"
            size="small"
            @click="roledistr(scope.row)"
            >教师角色</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="clickReset(scope.row.id, scope.row.name)"
            >重置密码</el-button
          >
          <el-button type="text" size="small" @click="editor(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            class="delete_btn"
            size="small"
            @click="clickDeleteTeacher(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <el-pagination
      background
      layout="total,prev,pager,next,sizes"
      :total="teacher.totalCount"
      :page-size="teacher.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="teacher.curPage"
      @current-change="currentChange"
      @size-change="handleSizeChange"
    ></el-pagination>

    <!-- 教师角色分配 -->
    <el-dialog
      width="30%"
      title="设置教师角色"
      :visible.sync="roleDialogForm"
      center
    >
      <el-form :model="roledistribution">
        <div class="roledialog">请为该教师分配角色</div>
        <el-form-item label="选择角色" label-width="100px">
          <el-select v-model="roledistribution.role" placeholder="请选择角色">
            <el-option label="学校管理员" value="-1004"></el-option>
            <el-option label="校长" value="-1006"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="roleDialogForm = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="determineRoled"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑教师信息 -->
    <el-dialog
      width="770px"
      title="修改信息"
      :before-close="teacherFields"
      :visible.sync="editorDialog"
    >
      <el-form
        :model="teacherInformation"
        :rules="teacherRules"
        ref="teacherEditor"
        :inline="true"
      >
        <el-form-item label="教师姓名" label-width="116px" prop="name">
          <el-input
            v-model.trim="teacherInformation.name"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="教师手机号" label-width="116px" prop="mobile">
          <el-input
            v-model.trim="teacherInformation.mobile"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" label-width="116px" prop="sex">
          <el-select
            v-model="teacherInformation.sex"
            placeholder="请选择性别"
            style="width: 200px"
          >
            <el-option label="男" value="0"></el-option>
            <el-option label="女" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科室" label-width="116px" prop="departmentId">
          <el-select
            v-model="teacherInformation.departmentId"
            placeholder="请选择科室"
            style="width: 200px"
          >
            <el-option
              v-for="item in departmentList"
              :key="item.departmentId"
              :label="item.departmentName"
              :value="item.departmentId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="介绍" label-width="116px" prop="introduction">
          <div class="edit_containers">
            <quill-editor
              v-model="teacherInformation.introduction"
              ref="myQuillEditor"
              style="width: 530px"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)"
            >
            </quill-editor>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editorDialog = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="addEditor('teacherEditor')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加教师 -->
    <el-dialog
      width="770px"
      title="添加教师"
      :before-close="teacherAddFields"
      :visible.sync="addEditorDialog"
    >
      <el-form
        :model="teacherInformations"
        :rules="teacherRules"
        ref="teacherAdd"
        :inline="true"
      >
        <el-form-item label="教师姓名" label-width="116px" prop="name">
          <el-input
            style="width: 200px"
            v-model.trim="teacherInformations.name"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="教师手机号" label-width="116px" prop="mobile">
          <el-input
            maxlength="11"
            style="width: 200px"
            v-model.trim="teacherInformations.mobile"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" label-width="116px" prop="sex">
          <el-select
            v-model="teacherInformations.sex"
            placeholder="请选择性别"
            style="width: 200px"
          >
            <el-option label="男" value="0"></el-option>
            <el-option label="女" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科室" label-width="116px" prop="departmentId">
          <el-select
            v-model="teacherInformations.departmentId"
            placeholder="请选择科室"
            style="width: 200px"
          >
            <el-option
              v-for="item in departmentList"
              :key="item.departmentId"
              :label="item.departmentName"
              :value="item.departmentId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="介绍" label-width="116px" prop="introduction">
          <div class="edit_containers">
            <quill-editor
              v-model="teacherInformations.introduction"
              ref="myQuillEditor"
              style="width: 530px"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)"
            >
            </quill-editor>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="quxiaoAdd">取 消</el-button>
        <el-button size="small" type="primary" @click="addEditors('teacherAdd')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 教师分工 普通学校-->
    <el-dialog
      :title="laborclass.name + '教师'"
      top="35px"
      :visible.sync="laborDialog"
      width="40%"
      :before-close="cancelLabor"
    >
      <!-- <span>{{ laborclass.name }}教师</span> -->
      <div>已设置分工</div>
      <div class="labor_yi">
        <div
          v-for="(item, index) in laborclass.ShowWorkList"
          class="labor_yi_g"
          :key="index"
        >
          <div>
            <span
              v-if="flagLabor(item.subjectName)"
              style="margin-right: 10px; float: left"
              >{{ item.subjectName }}:</span
            >
          </div>
          <div
            style="margin-left: 40px"
            v-for="(it, idx) in laborclass.workList"
            :key="idx"
          >
            <el-tag
              v-if="item.subject == it.subject"
              :key="it.classesId"
              class="el__tag__subject_item"
              size="small"
              closable
              @close="removeSubjectItem(idx, it)"
            >
              {{ it.gradeName }} {{ it.classesName }}
            </el-tag>
          </div>
        </div>
      </div>
      <div>1、请先选择科目</div>
      <div class="labor_subject">
        <div
          class="xu_body_child"
          v-for="(item, index) in subjectLists"
          :key="index"
          :style="{
            color: selectSubject == item.code ? 'white' : '#606266',
            backgroundColor: selectSubject == item.code ? '#409eff' : 'white',
          }"
          @click="clickSubject(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="class_labor">
        <div>2、再选班级</div>
        <div class="labor_class">
          <div
            class="class_two"
            v-for="(item, index) in gradeClassList"
            :key="index"
          >
            <div>{{ item.name }}：</div>
            <div
              v-for="(items, index) in item.classesList"
              :key="index"
              class="xu_body_child"
              :style="{
                color:
                  ClassArray.length > 0 && ClassArray.indexOf(items.id) > -1
                    ? 'white'
                    : '#606266',
                backgroundColor:
                  ClassArray.length > 0 && ClassArray.indexOf(items.id) > -1
                    ? '#409eff'
                    : 'white',
              }"
              @click="clickLabor(item, items)"
            >
              {{ items.title }}
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelLabor">取 消</el-button>
        <el-button size="small" type="primary" @click="baocunLabor"
          >保存分工</el-button
        >
      </span>
    </el-dialog>
    <!-- 教师分工 校外机构 -->
    <el-dialog
      :title="laborclass.name + '教师'"
      top="35px"
      :visible.sync="laborDialogX"
      width="40%"
      :before-close="cancelLabor"
    >
      <div>已设置分工</div>
      <div class="labor_yi">
        <div
          v-for="(item, index) in laborclass.ShowWorkList"
          class="labor_yi_g"
          :key="index"
        >
          <div>
            <span
              v-if="flagLabor(item.subjectName)"
              style="margin-right: 10px; float: left"
              >{{ item.subjectName }}:</span
            >
          </div>
          <div
            style="margin-left: 40px"
            v-for="(it, idx) in laborclass.workList"
            :key="idx"
          >
            <el-tag
              v-if="item.subjectName == it.subjectName"
              :key="it.classesId"
              class="el__tag__subject_item"
              size="small"
              closable
              @close="removeSubjectItem(idx, it)"
            >
              {{ it.gradeName }} {{ it.classesName }}
            </el-tag>
          </div>
        </div>
      </div>
      <div>1、请先选择科目</div>
      <div class="labor_subject">
        <div
          class="xu_body_child"
          v-for="(item, index) in courseList"
          :key="index"
          :style="{
            color: selectSubject == item.courseId ? 'white' : '#606266',
            backgroundColor:
              selectSubject == item.courseId ? '#409eff' : 'white',
          }"
          @click="clickSubject(item)"
        >
          <span> {{ item.courseName }}</span>
        </div>
      </div>
      <div class="class_labor">
        <div>2、再选班级</div>
        <div class="labor_class">
          <div
            class="class_two"
            v-for="(item, index) in gradeClassList"
            :key="index"
          >
            <div>{{ item.name }}：</div>
            <div
              v-for="(items, index) in item.classesList"
              :key="index"
              class="xu_body_child"
              :style="{
                color:
                  ClassArray.length > 0 && ClassArray.indexOf(items.id) > -1
                    ? 'white'
                    : '#606266',
                backgroundColor:
                  ClassArray.length > 0 && ClassArray.indexOf(items.id) > -1
                    ? '#409eff'
                    : 'white',
              }"
              @click="clickLabor(item, items)"
            >
              {{ items.title }}
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelLabor">取 消</el-button>
        <el-button size="small" type="primary" @click="baocunLabor"
          >保存分工</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量导入教师 -->
    <el-dialog title="批量添加" :visible.sync="batchDialog" width="30%" center>
      <div class="downmuban">
        没有下载模板？<a
          href="https://file.jingshidata.com/temp/import/教师导入模版.xlsx"
          target="_blank"
          download="批量添加教师.xlsx"
          >猛戳这里</a
        >
      </div>
      <div>
        上传Excel:
        <bulk-import :token="token" :schoolId="userId" @updateData="search" />
      </div>
      <div class="downtext">
        备注：新增老师成功后，老师使用手机号登录，初始密码为 手机号后六位
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getdepartmentlist } from '@/api/departmen'
import { quillEditor } from 'vue-quill-editor' //调用编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import bulkImport from './components/BulkImport.vue'
import {
  teacherLists,
  resetPassword,
  deleteTeacher,
  roleUser,
  addEditor,
  gradeClassList,
  subjectList,
  exportTeacher,
  dexportTeacher,
  roleList,
  deletdRoleUser,
  teacherWorkSetting,
  WorkCheckSubject,
  selectTeacher,
  selectCourseList,
  saveTeacherWork,
  verifyTeacherWork,
  cancelTeacherWork,
  onClearTeacherDivision,
} from '@/api/home'
import { initWxConfig } from '@/api/initWxConfig'
initWxConfig(this)
export default {
  components: { quillEditor, bulkImport },
  data() {
    var mobiles = (rule, value, callback) => {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!value) {
        return callback(new Error('手机号不能为空'))
      }
      setTimeout(() => {
        if (myreg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号格式'))
        }
      }, 100)
    }
    return {
      authSource: '',
      editorOption: {
        placeholder: '在此编辑介绍信息',
        modules: {
          toolbar: [['bold', 'italic', 'underline']],
        },
      },
      schoolName: '',
      teacher: {
        // 页码
        curPage: 1,
        // 每页显示条数
        pageSize: 20,
        // 数据总条数
        totalCount: 1,
        departmentId: '',
        // 姓名
        name: '',
        // 手机号
        mobile: '',
      },
      //   教师列表
      teachersList: [],

      // 角色分配
      roledistribution: {
        role: '',
      },
      userId: null,
      token: '',
      roleDialogForm: false,
      teacherid: 0,
      roleType: '',
      teacherInformation: {
        name: '',
        mobile: '',
        departmentId: '',
        schoolId: 0,
        sex: '',
        id: 0,
        introduction: '',
      },
      teacherInformations: {
        schoolId: 0,
        departmentId: '',
        name: '',
        mobile: '',
        sex: '',
        introduction: '',
      },
      editorDialog: false,
      laborDialog: false,
      gradeClassList: [],
      laborclass: [],
      checkboxGroup: [],
      subjectLists: [],
      classesId: 0,
      subjectName: '',
      addEditorDialog: false,
      batchDialog: false, //批量添加教师开关
      roleLists: [], //角色列表
      workList: [],
      listWork: [],
      datas: [],
      dialogAction: '',
      disabledName: '',
      jieliuf: false,
      timess: '',
      teacherRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: mobiles, trigger: 'blur' },
        ],
      },
      selectSubject: '',
      selectClassArray: [],
      ClassArray: [],
      copyworkList: [],
      roleTypes: localStorage.getItem('roleType'),
      departmentList: [], //科室列表
      courseList: [], //课程列表
      laborDialogX: false,
      type: '',
      typeTime: '',
      teacherVoList: [],
      teacherIds: '',
      gradeLists: '',
    }
  },
  mounted() {
    this.token = this.$route.query.token
    if (!localStorage.getItem('token')) {
      localStorage.setItem('token', token)
    }
    this.timess = setInterval(() => {
      this.clearIntervals()
    }, 500)
    this.type = localStorage.getItem('type')
  },
  methods: {
    // 一键清除教师分工
    onClearTeacherDivision() {
      this.$confirm('此操作将清除所有教师分工, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // token
          onClearTeacherDivision()
            .then((res) => {
              console.log(res.data)
              if (res.data.code && res.data.code == 0) {
                this.$message.success('清除成功！')
                this.teacherLists()
              }
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {})
    },
    clearIntervals() {
      if (this.userId === null) {
        let info = JSON.parse(localStorage.getItem('info'))
        this.authSource = info.authSource
        this.userId = localStorage.getItem('schoolIds')
        this.schoolName = localStorage.getItem('schoolName')
        this.token = localStorage.getItem('token')
        this.teacherInformations.schoolId = localStorage.getItem('schoolIds')
      } else {
        this.teacherLists()
        this.roleList()
        this.getdepartmentlist()
        this.selectCourseList()
        this.gradeClassLists()
        clearInterval(this.timess)
      }
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    teacherFields() {
      this.editorDialog = false
      this.$refs.teacherEditor.resetFields()
    },
    teacherAddFields() {
      this.addEditorDialog = false
      this.$refs.teacherAdd.resetFields()
    },
    // 查詢教師列表
    async teacherLists() {
      // console.log(this.teacher.pageSize)
      try {
        const { data: res } = await teacherLists({
          curPage: this.teacher.curPage,
          schoolId: this.userId,
          name: this.teacher.name,
          departmentId: this.teacher.departmentId,
          mobile: this.teacher.mobile,
          active: this.teacher.active,
          pageSize: this.teacher.pageSize,
        })
        let _data = res.data.dataList
        console.log(res.data)
        // eslint-disable-next-line no-unused-vars
        _data.map((item, index) => {
          let _arr = []
          item.workList.map((key, ii) => {
            _arr.push({
              subjectName: key.subjectName,
              subject: key.subject,
            })
            item.ShowWorkList = this.unique(_arr)
          })
        })
        this.teachersList = _data
        this.teacher.totalCount = res.data.totalCount
        // this.dataHandel()
      } catch (err) {
        console.log(err)
      }
    },
    // 去重
    unique(songs) {
      let result = {}
      let finalResult = []
      for (let i = 0; i < songs.length; i++) {
        result[songs[i].subjectName] = songs[i]
        //因为songs[i].name不能重复,达到去重效果,且这里必须知晓"name"或是其他键名
      }
      //现在result内部都是不重复的对象了，只需要将其键值取出来转为数组即可
      for (let item in result) {
        finalResult.push(result[item])
      }
      return finalResult
    },
    // 分页页码变化
    currentChange(e) {
      this.teacher.curPage = e
      // 调用查询教师列表
      this.teacherLists()
    },
    handleSizeChange(val) {
      this.teacher.curPage = 1
      this.teacher.pageSize = val
      this.teacherLists()
    },

    // 查询角色列表
    async roleList() {
      const { data: res } = await roleList()
      this.roleLists = res.data
    },
    // 点击重置密码
    clickReset(reset, roleType) {
      this.$confirm(
        `您确定要重置 <span style="color:#409EFF;margin:0 10px;">${roleType}</span>教师的密码么? 重置后的密码为:000000`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.resetPassword(reset)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置',
          })
        })
    },
    // 重置密码
    async resetPassword(reset) {
      try {
        const res = await resetPassword({
          userId: reset,
          roleType: 'teacher',
        })
        if (res.status !== 200) {
          this.$message.error('重置失败，请稍后重试！！')
        }
        this.$message({
          message: res.data.msg,
          type: 'success',
        })
      } catch (err) {
        console.log(err)
      }
    },
    // 点击删除教师
    clickDeleteTeacher(row) {
      this.$confirm(
        `您确定要删除 <span style="color:#409EFF;margin:0 10px;">${row.name}</span>教师么?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.deleteTeacher(row.id)
          this.$message({
            type: 'success',
            message: '删除成功',
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 删除教师
    async deleteTeacher(teacherId) {
      const res = await deleteTeacher(teacherId)
      this.teacherLists()
    },
    // 点击打开角色分配弹窗
    roledistr(row) {
      this.roleDialogForm = true
      this.teacherid = row.id
      if (row.roleType.indexOf('教师') !== -1) {
        this.roleType = 'teacher'
      }
    },
    async determineRoled() {
      const res = await roleUser({
        roleId: this.roledistribution.role,
        roleType: this.roleType,
        userIds: this.teacherid,
      })
      this.roleDialogForm = false
      this.teacherLists()
    },
    // 编辑教师信息（打开弹窗）
    async editor(row) {
      const { data: res } = await selectTeacher(row.id)
      this.teacherInformation.name = res.data.name
      this.teacherInformation.mobile = res.data.mobile
      this.teacherInformation.id = res.data.id
      this.teacherInformation.departmentId = res.data.departmentId
      this.teacherInformation.introduction = res.data.introduction
      // 防止性别为空时toString报错
      if (res.data.sex == null) {
        this.teacherInformation.sex = res.data.sex
      } else {
        this.teacherInformation.sex = res.data.sex.toString()
      }
      this.teacherInformation.schoolId = res.data.schoolId
      this.editorDialog = true
    },
    // 获取科室信息
    async getdepartmentlist() {
      let res = await getdepartmentlist({
        schoolId: this.userId,
      })
      if (res) {
        console.log(res)
        this.departmentList = res.data.data
      } else {
        console.log(res)
      }
    },
    // 修改教师信息
    addEditor(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editorAdd()
        } else {
          return false
        }
      })
    },
    // 修改
    async editorAdd() {
      const { data: res } = await addEditor({ ...this.teacherInformation })
      if (res.code !== '0') {
        this.$message.error(res.msg)
        return false
      }
      this.$message({
        message: '修改成功',
        type: 'success',
      })
      this.editorDialog = false
      this.teacherLists()
      this.$refs.teacherEditor.resetFields()
    },
    // 添加教师
    async addEditors(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editorAdds()
        } else {
          return false
        }
      })
    },

    // 取消添加
    quxiaoAdd() {
      this.addEditorDialog = false
      this.$refs.teacherAdd.resetFields()
    },

    // 添加
    async editorAdds() {
      const { data: res } = await addEditor(this.teacherInformations)
      if (res.code !== '0') {
        this.$message.error(res.msg)
        return false
      }
      this.$message({
        message: '添加成功',
        type: 'success',
      })
      this.addEditorDialog = false
      this.teacherLists()
      this.$refs.teacherAdd.resetFields()
    },

    // 教师分工（打开弹窗）
    teacherLabor(row) {
      if (this.type == 8) {
        this.teacherIds = row.id
        this.laborclass = row
        this.copyworkList = row.workList
        this.laborDialogX = true
        return false
      }
      this.dialogAction = '设置教师分工'
      this.laborclass = row
      this.copyworkList = row.workList
      this.subjectList()
      this.laborDialog = true
    },
    // 已设置分工 删除最后一个数据时 课程名称也删除
    flagLabor(name) {
      let flag = false
      this.laborclass.workList.forEach((item) => {
        if (name == item.subjectName) {
          flag = true
        }
      })
      return flag
    },
    flagCourse(name) {
      let flag = true
      for (const key in this.laborclass.ShowWorkList) {
        if (name == this.laborclass.ShowWorkList[key].subjectName) {
          flag = false
        }
      }
      return flag
    },
    hidedialogVisible() {
      this.dialogVisible = false
    },
    // 教师分工弹窗删除
    removeSubjectItem(i, e) {
      if (this.type == 8) {
        let classIdList = []
        classIdList.push(e.classesId)
        let params = {
          teacherId: this.teacherIds,
          mechanismTeacherVoList: [
            { classIdList: classIdList, courseId: e.subjectId },
          ],
        }
        cancelTeacherWork(params).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: '删除成功',
              type: 'success',
            })
          }
        })
      }
      const index = this.ClassArray.indexOf(e.classesId)
      this.ClassArray.splice(index, 1)
      this.copyworkList.splice(i, 1)
    },

    // 获取班级列表
    async gradeClassLists() {
      const { data: res } = await gradeClassList({
        schoolId: this.userId,
      })
      this.gradeClassList = res.data
    },

    // 获取全部学科列表
    async subjectList() {
      const { data: res } = await subjectList({
        schoolId: this.userId,
      })
      this.subjectLists = res.data
      this.gradeClassLists()
    },
    // 科目选择
    clickSubject(item) {
      this.ClassArray = []
      // 机构的操作
      if (this.type == 8) {
        this.selectSubject = item.courseId
        this.listWork.subjectId = item.courseId
        this.listWork.subjectName = item.courseName
        // 判断科目列表是否为空
        if (this.laborclass.ShowWorkList == null) {
          // 改变ShowWorkList数据格式为数组（原始格式为null）
          this.laborclass.ShowWorkList = []
          this.laborclass.ShowWorkList.push({
            subject: item.courseId,
            subjectName: item.courseName,
          })
        } else {
          const idx =
            this.laborclass.ShowWorkList.findIndex(
              (items) => items.subjectName == item.courseName
            ) == -1
          if (idx) {
            this.laborclass.ShowWorkList.push({
              subject: item.courseId,
              subjectName: item.courseName,
            })
          }
        }
        return false
      }
      // 学校端 操作
      this.disabledName = ''
      this.selectSubject = item.code
      this.listWork.subject = item.code
      this.listWork.subjectName = item.name
      this.gradeLists = item.grades
      // 判断科目列表是否为空
      if (this.laborclass.ShowWorkList == null) {
        // 改变ShowWorkList数据格式为数组（原始格式为null）
        this.laborclass.ShowWorkList = []
        this.laborclass.ShowWorkList.push({
          subject: item.code,
          subjectName: item.name,
        })
      } else {
        const idx =
          this.laborclass.ShowWorkList.findIndex(
            (items) => items.subjectName == item.name
          ) == -1
        if (idx) {
          this.laborclass.ShowWorkList.push({
            subject: item.code,
            subjectName: item.name,
          })
        }
      }

      // this.gradeClassLists()
    },
    // 科目点击事件
    clickLabor(item, items) {
      // 判断要添加的科目是否为空
      if (this.selectSubject == '') {
        this.$message.error('要添加的科目不能为空')
        return
      }
      // 机构端操作
      if (this.type == 8) {
        verifyTeacherWork({
          courseId: this.selectSubject,
          classId: items.id,
        }).then((res) => {
          if (res.data.data == 0) {
            if (this.ClassArray.indexOf(items.id) !== -1) {
              const index = this.ClassArray.indexOf(items.id)
              this.ClassArray.splice(index, 1)
              this.selectClassArray.splice(index, 1)
              for (const key in this.laborclass.workList) {
                if (
                  items.id == this.laborclass.workList[key].classesId &&
                  this.selectSubject == this.laborclass.workList[key].subjectId
                ) {
                  this.laborclass.workList.splice(key, 1)
                }
              }
              return
            }
            this.ClassArray.push(items.id)
            const datas = {
              // gradeId: item.gradeId,
              // gradeName: item.name,
              classesId: items.id,
              classesName: items.title,
            }
            this.laborclass.workList.push({ ...datas, ...this.listWork })
            return false
          }
          this.$message('该班级已有任课老师，请重新选择')
        })
        return false
      }
      // 学校端操作
      console.log('items', items.gradeId)
      let idx = this.gradeLists.indexOf(items.gradeId)
      if (idx != -1) {
        WorkCheckSubject({
          classesId: items.id,
          subjectName: this.selectSubject,
        }).then((res) => {
          if (res.data.code == 0) {
            if (this.ClassArray.indexOf(items.id) !== -1) {
              const index = this.ClassArray.indexOf(items.id)
              this.ClassArray.splice(index, 1)
              this.selectClassArray.splice(index, 1)
              for (const key in this.laborclass.workList) {
                if (
                  items.id == this.laborclass.workList[key].classesId &&
                  this.selectSubject == this.laborclass.workList[key].subject
                ) {
                  this.laborclass.workList.splice(key, 1)
                }
              }
              return
            }

            // ClassArray 控制班级选中的状态
            this.ClassArray.push(items.id)
            // 班级年级数据
            const datas = {
              gradeId: item.gradeId,
              gradeName: item.name,
              classesId: items.id,
              classesName: items.title,
            }
            this.selectClassArray.push(datas)
            this.laborclass.workList.push({ ...datas, ...this.listWork })
          }
        })
      } else {
        this.$message.error('该年级没有开设此课程')
      }
    },
    // 已分工栏 删除功能
    async baocunLabor() {
      // 已分工栏 删除功能
      if (this.type == 8) {
        if (this.selectSubject == '') {
          this.$message.error('要添加的科目不能为空')
          return
        }
        if (this.laborclass.workList.length == 0) {
          this.$message.error('要添加的班级不能为空')
          return
        }
        let list = []
        this.laborclass.workList.forEach((item) => {
          const idx =
            list.findIndex((items) => items.courseId == item.subjectId) == -1
          if (idx) {
            list.push({ courseId: item.subjectId })
          }
        })

        list.forEach((item) => {
          item.classIdList = []
          this.laborclass.workList.forEach((items) => {
            if (item.courseId == items.subjectId) {
              item.classIdList.push(items.classesId)
            }
          })
        })
        const { data: res } = await saveTeacherWork({
          teacherId: this.laborclass.id,
          mechanismTeacherVoList: list,
        })
        this.laborDialogX = false
      } else {
        const { data: res } = await teacherWorkSetting({
          teacherId: this.laborclass.id,
          workList: this.laborclass.workList,
        })
      }
      this.workList = []
      this.selectSubject = ''
      this.selectClassArray = []
      this.ClassArray = []
      this.teacherLists()
      this.laborDialog = false
    },
    // 数据清除
    cancelLabor() {
      this.selectSubject = ''
      this.selectClassArray = []
      this.ClassArray = []
      this.laborDialog = false
      this.laborDialogX = false
      this.teacherLists()
    },

    search() {
      this.teacher.curPage = 1
      this.teacherLists()
    },
    // 导出教师信息
    async getApiExportTeacherList() {
      let schoolName = localStorage.getItem('schoolName') + '教师列表'
      const res = await dexportTeacher(this.userId, schoolName)
    },
    // 删除非 教师 身份的 教师角色
    async DeleteTeacherRole(item, obj) {
      if (this.authSource != 'system') {
        return false
      }
      if (item == '教师') {
        return false
      }
      this.$confirm(
        `您确定要删除<span style="color:#409EFF;margin:0 10px;">${obj.name}</span>教师的<span style="color:#409EFF;margin:0 10px;">${item}</span>的身份么?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.ApiDeteteUser(item, obj)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },

    // api 删除角色
    ApiDeteteUser(item, obj) {
      let roleId
      this.roleLists.map((k) => {
        if (k.name == item) {
          roleId = k.id
        }
      })
      deletdRoleUser({ roleType: 'teacher', userId: obj.id, roleId }).then(
        () => {
          this.teacherLists()
          this.$message({
            type: 'success',
            message: '删除成功',
          })
        }
      )
    },

    async selectCourseList() {
      const { data: res } = await selectCourseList()
      this.courseList = res.data
    },
  },
}
</script>
<style scoped>
#app {
  position: relative;
  /* padding-top: 20px; */
}

.basisInformation {
  font-size: 16px;
  font-weight: 700;
  /* margin-top: 10px; */
}

.el-divider {
  margin-top: 18px;
  margin-bottom: 16px;
}

.el-input {
  width: 200px;
}

.el-row {
  display: flex;
  justify-content: space-between;
}
.col_right {
  width: 400px;
}
.col_right .el-button:nth-child(1) {
  float: left;
  margin-right: 15px;
}

.roledialog {
  font-size: 18px;
  margin-bottom: 15px;
  margin-left: 30px;
}
.labor_yi {
  min-height: 50px;
  overflow-y: auto;
  border: 1px solid #bbb;
  padding: 3px 13px 13px;
  margin: 10px 0;
}
.labor_yi_g {
  width: 100%;
  min-height: 20px;
  display: inline-block;
}
.labor_subject {
  min-height: 50px;
  overflow-y: auto;
  border: 1px solid #bbb;
  padding: 3px 13px 13px;
  margin: 10px 0;
}
.labor_class {
  min-height: 50px;
  overflow-y: auto;
  border: 1px solid #bbb;
  padding: 3px 13px 13px;
  margin: 10px 0;
}
.class_two {
  margin-top: 10px;
}
.el-checkbox-button {
  margin-left: 10px;
  border: 1px solid #666666;
  margin-top: 5px;
}
.downmuban {
  margin-bottom: 50px;
}
.BulkImportCom {
  display: inline-block;
}
.downtext {
  margin: 50px 0 20px;
}
.is-Teacher {
  cursor: pointer;
  color: #409eff;
}

.check_box {
  display: inline-block;
}
.el__tag__subject_item {
  float: left;
  margin: 0 10px;
}
.xu_body_child {
  padding: 0 10px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid lightgray;
  margin-right: 10px;
  margin-top: 10px;
  line-height: 36px;
  cursor: pointer;
  display: inline-block;
}
.el-table__body .el-button + .el-button {
  margin-left: 20px;
}
/* .edit_container {
  height: 100px;
} */
</style>



// WEBPACK FOOTER //
// src/views/school/components/Teachermanger.vue